import type { ReactNode } from 'react';

export const symbol_fertile: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M520-835q32 38 61.5 76t56.5 80l194-145q7-5 15-6t16 3q8 4 12.5 11.5T880-800v320q0 83-31.5 156T763-197q-54 54-127 85.5T480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480v-320q0-8 4.5-15.5T97-827q8-4 16-3t15 6l193 145q27-42 57-80t62-76q8-9 18.5-14t21.5-5q11 0 21.5 5t18.5 14Zm201 596q99-99 99-241v-260L622-592q-39-63-69.5-105.5T480-791q-42 51-73.5 94.5T338-592L140-740v260q0 142 99 241t241 99q142 0 241-99ZM480-466Z"
		/>
	</svg>
);
